function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 8C9 7.85 8.93 7.72 8.83 7.63L4.83 4.13C4.74 4.05 4.63 4 4.5 4C4.22 4 4 4.22 4 4.5V11.5C4 11.78 4.22 12 4.5 12C4.63 12 4.74 11.95 4.83 11.87L8.83 8.37C8.93 8.28 9 8.15 9 8Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13 8C13 7.85 12.93 7.72 12.83 7.63L8.83 4.13C8.74 4.05 8.63 4 8.5 4C8.22 4 8 4.22 8 4.5V11.5C8 11.78 8.22 12 8.5 12C8.63 12 8.74 11.95 8.83 11.87L12.83 8.37C12.93 8.28 13 8.15 13 8Z"
});

var SvgCaretMostRight = function SvgCaretMostRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCaretMostRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/caret-most-right.cf166b80.svg";
export { ForwardRef as ReactComponent };